<div #menuButtons class="flex justify-end items-center gap-x-2" [class]="{'hidden': !showMenus}">
    
    @for (menu of menus; track menu.id) {

        <app-button 
            [label]="menu.label" 
            [color]="menu.buttonType!"
            (event)="toggleMenu(menu.id)" 
            [active]="isMenuActive(menu.id)" 
            [class.hidden]="!menu.isVisible"
            [disabled]="disabled"
        />
            
    }

</div>